import React from 'react';
import { Column, NumberMenu, ColumnType, Table, TableProps } from '@spins/react-table';
import { Formats } from '@spins/react-ui-library';
import ColoredValue from '../ColoredValue';
import { isValueDefined, titleCase } from 'utils/functions';

interface AccountsTableProps
  extends Pick<
    TableProps<any>,
    'error' | 'queryState' | 'rows' | 'totalRows' | 'showLoading' | 'onRowClick'
  > {}

const BrandsTable: React.FC<AccountsTableProps> = ({
  error,
  queryState,
  rows,
  showLoading,
  totalRows,
  onRowClick
}) => {
  const columns: Array<ColumnType<any>> = [
    {
      accessor: 'name',
      cell: (value: string) => (isValueDefined(value) ? titleCase(value) : '-'),
      header: 'Brand',
      width: 20,
      isDraggable: false
    },
    {
      accessor: 'sales',
      cell: (value: number) => (isValueDefined(value) ? Formats.currency(value) : '-'),
      header: 'Dollars',
      width: 8,
      filter: {
        renderer: (column: Column<any>, onApply: any) => (
          <NumberMenu column={column} onApply={onApply} />
        ),
        props: { decimals: 0 }
      },
      isDraggable: false
    },
    {
      accessor: 'salesDelta',
      cell: (value: number) =>
        isValueDefined(value) ? (
          <ColoredValue type="percentage" value={value} showPositiveSign={true} decimals={1} />
        ) : (
          '-'
        ),
      header: '$ Chg YAGO',
      width: 8,
      filter: {
        renderer: (column: Column<any>, onApply: any) => (
          <NumberMenu column={column} onApply={onApply} />
        ),
        props: { decimals: 1 }
      },
      isDraggable: false
    },
    {
      accessor: 'units',
      cell: (value: number) => (isValueDefined(value) ? Formats.number(value) : '-'),
      header: 'Units',
      width: 8,
      filter: {
        renderer: (column: Column<any>, onApply: any) => (
          <NumberMenu column={column} onApply={onApply} />
        ),
        props: { decimals: 0 }
      },
      isDraggable: false
    },
    {
      accessor: 'unitsDelta',
      cell: (value: number) =>
        isValueDefined(value) ? (
          <ColoredValue type="percentage" value={value} showPositiveSign={true} decimals={1} />
        ) : (
          '-'
        ),
      header: 'Units Chg YAGO',
      width: 8,
      filter: {
        renderer: (column: Column<any>, onApply: any) => (
          <NumberMenu column={column} onApply={onApply} />
        ),
        props: { decimals: 1 }
      },
      isDraggable: false
    },
    {
      accessor: 'pod',
      cell: (value: number) => (isValueDefined(value) ? Formats.number(value) : '-'),
      header: 'POD',
      width: 8,
      filter: {
        renderer: (column: Column<any>, onApply: any) => (
          <NumberMenu column={column} onApply={onApply} />
        ),
        props: { decimals: 0 }
      },
      isDraggable: false
    },
    {
      accessor: 'storesSelling',
      cell: (value: number) => (isValueDefined(value) ? Formats.number(value) : '-'),
      header: 'Stores Selling',
      width: 8,
      filter: {
        renderer: (column: Column<any>, onApply: any) => (
          <NumberMenu column={column} onApply={onApply} />
        ),
        props: { decimals: 0 }
      },
      isDraggable: false
    },
    {
      accessor: 'podGains',
      cell: (value: number) => (isValueDefined(value) ? Formats.number(value) : '-'),
      header: 'POD Gains',
      width: 8,
      filter: {
        renderer: (column: Column<any>, onApply: any) => (
          <NumberMenu column={column} onApply={onApply} />
        ),
        props: { decimals: 0 }
      },
      isDraggable: false
    },
    {
      accessor: 'podLosses',
      cell: (value: number) => (isValueDefined(value) ? Formats.number(value) : '-'),
      header: 'POD Losses',
      width: 8,
      filter: {
        renderer: (column: Column<any>, onApply: any) => (
          <NumberMenu column={column} onApply={onApply} />
        ),
        props: { decimals: 0 }
      },
      isDraggable: false
    },
    {
      accessor: 'voids',
      cell: (value: number) => (isValueDefined(value) ? Formats.number(value) : '-'),
      header: 'Voids',
      width: 8,
      filter: {
        renderer: (column: Column<any>, onApply: any) => (
          <NumberMenu column={column} onApply={onApply} />
        ),
        props: { decimals: 0 }
      },
      isDraggable: false
    },
    {
      accessor: 'opportunityGap',
      cell: (value: number) => (isValueDefined(value) ? Formats.currency(value) : '-'),
      header: 'Opp Gap',
      width: 8,
      filter: {
        renderer: (column: Column<any>, onApply: any) => (
          <NumberMenu column={column} onApply={onApply} />
        ),
        props: { decimals: 0 }
      },
      isDraggable: false
    }
  ];
  return (
    <Table
      columns={columns}
      error={error}
      layoutFixed={true}
      queryState={queryState}
      showLoading={showLoading}
      rows={rows}
      totalRows={totalRows}
      onRowClick={onRowClick}
    />
  );
};

export default BrandsTable;
